// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"720c14ec","439":"8479d1c7","453":"e9a6b3d2","478":"2e5c8854","524":"937586c2","543":"8429b2e8","601":"dac75f57","619":"97529f46","649":"83309fe0","695":"b7808e65","698":"fc5666b5","787":"f2d8fd74","863":"d25d1a00","960":"ab08b58b"}[chunkId] + ".chunk.js";
};